import { useQuery } from '@tanstack/react-query';
import { getEnumValues } from '../services/commonService';
import { EnumValueData } from '../models/enum';

export const useEnumValues = (enumTypeName: string, enabled: boolean = true) => {
  return useQuery<EnumValueData[]>({
    queryKey: ['enum-values', enumTypeName],
    queryFn: () => getEnumValues(enumTypeName),
    enabled,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
};
